// extracted by mini-css-extract-plugin
export default {"header_wrapper":"ListJabatan_header_wrapper__-bON9","header_container":"ListJabatan_header_container__Cha-5","table_wrapper":"ListJabatan_table_wrapper__svesX"};